import { dlPushEvent } from "@/analytics/gtm";
import { Button } from "@/components/ui/button";
import ImageSvg from "@/components/ui/image-svg";
import { ArrowRight } from "lucide-react";
import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function CotacaoNotFound() {
  useEffect(() => {
    dlPushEvent("cotacao_error", { error_type: "not_found" });
  }, []);

  return (
    <div className="flex flex-col max-w-6xl container max md:flex-row items-center justify-between gap-12 min-h-[80vh] px-6 py-10">
      
      <div className="max-w-lg text-left">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-n-primary mb-4">
          Parece que tivemos um problema para calcular o seu frete.
        </h2>

        <p className=" text-n-primary mb-10">
          Recomendamos refazer a sua cotação:
        </p>
        <Link to="/fazer-cotacao">
          <Button className="">
            Refazer cotação
            <ArrowRight className="ml-2 " />
          </Button>
        </Link>

        <div className="mt-8 text-sm">
          <p className="font-semibold">Dúvidas quanto ao seu pedido?</p>
          <p className="text-n-text-neutral">
            Ligue para <span className="font-bold">0800 878 0708</span>
          </p>
        </div>
      </div>

      <div className="w-full max-w-md">
        <ImageSvg
          src="/mulher-celular.svg"
          alt="Erro ao calcular frete"
          className="w-full h-auto"
        />
      </div>
    </div>
  );
}
